<template>
    <div class="PersonalAccountLayout">
        <div class="PersonalAccountLayout-menuContainer">
            <MainMenu />
        </div>
        <div class="PersonalAccountLayout-contentContainer">
            <transition name="slide-fade">
                <router-view />
            </transition>
        </div>
    </div>
</template>

<script>

import MainMenu from '@/components/MainMenu.vue';
import Vue from "vue";
import Component from "vue-class-component";

@Component({
    components: {
        MainMenu,
    },
})
export default class PersonalAccountLayout extends Vue {

}

</script>

<style lang="scss" scoped>
.PersonalAccountLayout{
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    padding: 90px 0 90px 100px;

    @media (max-width: $f2m-desktop-breakpoint) {
        padding: 60px 20px;
        display: block;
    }

    &.hidden{
        opacity: 0
    }

    &-menuContainer {
        height: 100%;
        @media (max-width: $f2m-desktop-breakpoint) {
            display: none;
        }
    }

    &-contentContainer {
        height: 100%;
        flex-grow: 1;
        margin-left: 40px;
        margin-right: 40px;
        max-width: 890px;
        @media (max-width: $f2m-desktop-breakpoint) {
            margin-left: 0;
            margin-right: 0;
            max-width: 100%;
        }
    }
}


</style>
